export function createComparisonOperators() {
    return {
        $eq: (fieldValue, conditionValue) => {
            if (Array.isArray(fieldValue)) {
                return fieldValue.includes(conditionValue);
            }
            return fieldValue === conditionValue;
        },
        $ne: (fieldValue, conditionValue) => {
            if (Array.isArray(fieldValue)) {
                return !fieldValue.includes(conditionValue);
            }
            return fieldValue !== conditionValue;
        },
        $gt: (fieldValue, conditionValue) => {
            if (typeof conditionValue !== 'number')
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.some((value) => typeof value === 'number' && value > conditionValue);
            }
            if (typeof fieldValue === 'number') {
                return fieldValue > conditionValue;
            }
            return false;
        },
        $gte: (fieldValue, conditionValue) => {
            if (typeof conditionValue !== 'number')
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.some((value) => typeof value === 'number' && value >= conditionValue);
            }
            if (typeof fieldValue === 'number') {
                return fieldValue >= conditionValue;
            }
            return false;
        },
        $lt: (fieldValue, conditionValue) => {
            if (typeof conditionValue !== 'number')
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.some((value) => typeof value === 'number' && value < conditionValue);
            }
            if (typeof fieldValue === 'number') {
                return fieldValue < conditionValue;
            }
            return false;
        },
        $lte: (fieldValue, conditionValue) => {
            if (typeof conditionValue !== 'number')
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.some((value) => typeof value === 'number' && value <= conditionValue);
            }
            if (typeof fieldValue === 'number') {
                return fieldValue <= conditionValue;
            }
            return false;
        },
        $in: (fieldValue, conditionValue) => {
            if (!Array.isArray(conditionValue))
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.some((value) => conditionValue.includes(value));
            }
            return conditionValue.includes(fieldValue);
        },
        $nin: (fieldValue, conditionValue) => {
            if (!Array.isArray(conditionValue))
                return false;
            if (Array.isArray(fieldValue)) {
                return fieldValue.every((value) => !conditionValue.includes(value));
            }
            return !conditionValue.includes(fieldValue);
        },
    };
}
